import { render, staticRenderFns } from "./update-button.vue?vue&type=template&id=9655f41a&scoped=true&"
import script from "./update-button.vue?vue&type=script&lang=ts&"
export * from "./update-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9655f41a",
  null
  
)

export default component.exports